// extracted by mini-css-extract-plugin
export var addButton = "_ob-0";
export var border = "_ob-8";
export var check = "_ob-h";
export var danger = "_ob-6";
export var dropdownContainer = "_ob-1";
export var editModalBody = "_ob-j";
export var footerContainer = "_ob-i";
export var fullWidth = "_ob-a";
export var hide = "_ob-9";
export var icon = "_ob-3";
export var input = "_ob-7";
export var inputFlex = "_ob-b";
export var inputWrapper = "_ob-c";
export var manualFocus = "_ob-5";
export var optionButton = "_ob-4";
export var pillWrapper = "_ob-e";
export var pointer = "_ob-2";
export var showOverflow = "_ob-f";
export var tagsFlex = "_ob-d";
export var xButton = "_ob-g";